import { Box, Button, Hidden } from "@material-ui/core"
import React from "react"
import { useHistory } from "react-router-dom"
import { Icon } from ".."
import { useMutationCompleteUserTrainingModuleKnowledge } from "../../data"
import { toId } from "../../utils"
import { Blockquote } from "../Blockquotes"
import { LoadingSpinner } from "../LoadingSpinner"

const TrainingArticleFooter = ({ userTraining, module, moduleKnowledge }) => {
  const history = useHistory()
  const [completeUserTrainingModuleKnowledge, { loading }] = useMutationCompleteUserTrainingModuleKnowledge()

  const handleContinue = async () => {
    await completeUserTrainingModuleKnowledge({
      variables: {
        userTraining: toId(userTraining),
        module: toId(module),
        moduleKnowledge: toId(moduleKnowledge),
      },
    })
    handleNavigateToTraining()
  }

  const handleNavigateToTraining = () => {
    history.push(`/knowledge/training/${toId(userTraining)}`)
  }

  if (!userTraining || !module || !moduleKnowledge) {
    return null
  }

  const completed = Boolean(moduleKnowledge.completedAt)

  return (
    <Blockquote
      icon={<Icon name="training" />}
      title={`${userTraining.name} - ${module.name}`}
      body={
        <>
          {!completed && (
            <>
              <Box mb={2}>
                Once you have read and understand the content of this module, click below to continue with your
                training. You can return and refer to this content at any time through the Knowledge Base.
              </Box>
              <Hidden smDown>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleContinue}
                  disabled={loading}
                  data-cy="Button-continue"
                >
                  {!loading && <>I've read and understand this content</>}
                  {loading && <LoadingSpinner size="24px" delay={false} />}
                </Button>
              </Hidden>
              <Hidden mdUp>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleContinue}
                  disabled={loading}
                  data-cy="Button-continue"
                >
                  {!loading && <>I've read and understand this content</>}
                  {loading && <LoadingSpinner size="24px" delay={false} />}
                </Button>
              </Hidden>
            </>
          )}
          {completed && (
            <>
              <Box mb={2}>You have already indicated you have read and understood this training content.</Box>
              <Button variant="contained" color="primary" onClick={handleNavigateToTraining}>
                Continue
              </Button>
            </>
          )}
        </>
      }
      cy="TrainingArticleFooter"
    />
  )
}

export { TrainingArticleFooter }
